module.exports = __webpack_public_path__ + "img/btf-1.16f5b277.png";